module.exports = __webpack_public_path__ + "img/book.436055f3.jpg";